import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1 from '@rhinosaas/reb-ngx/reb-ngx-divider';
import { RebNgxDividerModule } from '@rhinosaas/reb-ngx/reb-ngx-divider';

class RebNgxListableCardComponent {
    constructor() {
        /**
         * Border radius of the listable card
         */
        this.borderRadius = 'lg';
        /**
         * Border with of the listable card
         */
        this.borderWidth = 'xs';
        /**
         * Shadow of the listable card
         */
        this.shadow = 'sm';
        /**
         * Width of the listable card
         */
        this.width = 'auto';
        /**
         * Collection of data that will be shown in the listed cards
         */
        this.collection = [];
        /**
         * adds a divider between cards
         */
        this.useDivider = true;
    }
    get classes() {
        return [
            `
      border-radius--${this.borderRadius}
      border--${this.borderWidth}
      shadow--${this.shadow}
      size--${this.width}
      `
        ];
    }
}
RebNgxListableCardComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxListableCardComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
RebNgxListableCardComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.10", type: RebNgxListableCardComponent, selector: "reb-ngx-listable-card", inputs: { borderRadius: "borderRadius", borderWidth: "borderWidth", shadow: "shadow", width: "width", collection: "collection", itemTemplate: "itemTemplate", useDivider: "useDivider" }, ngImport: i0, template: "<div class=\"rn-listable-card\" [ngClass]=\"classes\">\n  <ng-container *ngFor=\"let item of collection; let index = index\">\n    <ng-container\n      *ngTemplateOutlet=\"itemTemplate; context: { $implicit: item }\"\n    ></ng-container>\n    <reb-ngx-divider\n      *ngIf=\"useDivider && index < collection.length - 1\"\n    ></reb-ngx-divider>\n  </ng-container>\n</div>\n", styles: [".rn-listable-card{border-color:var(--palette-grey-95);border-style:solid}\n"], components: [{ type: i1.RebNgxDividerComponent, selector: "reb-ngx-divider", inputs: ["marginHorizontal", "marginVertical"] }], directives: [{ type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxListableCardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'reb-ngx-listable-card', template: "<div class=\"rn-listable-card\" [ngClass]=\"classes\">\n  <ng-container *ngFor=\"let item of collection; let index = index\">\n    <ng-container\n      *ngTemplateOutlet=\"itemTemplate; context: { $implicit: item }\"\n    ></ng-container>\n    <reb-ngx-divider\n      *ngIf=\"useDivider && index < collection.length - 1\"\n    ></reb-ngx-divider>\n  </ng-container>\n</div>\n", styles: [".rn-listable-card{border-color:var(--palette-grey-95);border-style:solid}\n"] }]
        }], propDecorators: { borderRadius: [{
                type: Input
            }], borderWidth: [{
                type: Input
            }], shadow: [{
                type: Input
            }], width: [{
                type: Input
            }], collection: [{
                type: Input
            }], itemTemplate: [{
                type: Input
            }], useDivider: [{
                type: Input
            }] } });

class RebNgxListableCardModule {
}
RebNgxListableCardModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxListableCardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
RebNgxListableCardModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxListableCardModule, declarations: [RebNgxListableCardComponent], imports: [CommonModule, RebNgxDividerModule], exports: [RebNgxListableCardComponent] });
RebNgxListableCardModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxListableCardModule, imports: [[CommonModule, RebNgxDividerModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxListableCardModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [RebNgxListableCardComponent],
                    imports: [CommonModule, RebNgxDividerModule],
                    exports: [RebNgxListableCardComponent]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { RebNgxListableCardComponent, RebNgxListableCardModule };
